/**
 * Fetches ICS from the fulfillment download action and triggers a file download.
 * Use redemptionToken for guest (instant redemption modal) or omit for session auth (order history).
 */
export async function downloadFulfillmentIcs(fulfillmentId: string, redemptionToken?: string | null): Promise<void> {
  const response = await fetch(`/fulfillment/${fulfillmentId}/download_ics`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ redemption_token: redemptionToken ?? null }),
  });
  if (!response.ok) return;
  const blob = await response.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = 'webinar.ics';
  a.click();
  URL.revokeObjectURL(url);
}

/** Returns an onAddToCalendar handler with optional redemption token (e.g. for instant redemption modal). */
export function createAddToCalendarHandler(redemptionToken?: string | null): (fulfillmentId: string) => void {
  return (fulfillmentId: string) => downloadFulfillmentIcs(fulfillmentId, redemptionToken);
}
